import { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateUserStatus } from "../../../store/redux_auth/authSlice";

function AcceptedAccountStatusMessage() {
  const [seconds, setSeconds] = useState(10);
  const dispatch = useDispatch();

  // Update Redux status on mount
  useEffect(() => {
    dispatch(updateUserStatus({ 
      account_status: "LE", 
      stripe_connected_account: true 
    }));
  }, [dispatch]);

  useEffect(() => {
    if (seconds === 0) {
      // Hard redirect with full page reload
      window.location.href = "/onboard";
      return;
    }

    const timer = setTimeout(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds]);

  return (
    <Fragment>
      <div>
        <h1>Your Account Has Been Successfully Connected!</h1>
        <br />
        <p>
          We’re excited to let you know that your connected account has been
          successfully accepted by Stripe. You’re now ready to start using our
          platform to its fullest potential.
        </p>
        <br></br>
        <h3>You will be redirected in: {seconds} seconds</h3>
      </div>
    </Fragment>
  );
}

export default AcceptedAccountStatusMessage;
